import { DialogContent as MuiDialogContent, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
  overflowY: "visible",

  ".MuiAutocomplete-root, & > .MuiFormControl-root": {
    width: "45%",
  },
});

export const Cell = styled(Grid)({
  display: "flex",
  flexFlow: "column",
  lineHeight: "0.9em",
});
